import { z } from 'zod';

export const warehouseFormSchema = z.object({
  code: z.string().trim().min(1, '代號不能為空').max(50, '代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  remark: z.string().max(500, '備註最多 500 字').optional().or(z.literal('')),
});
